module.exports = __webpack_public_path__ + "img/service.ba09f098.png";